module.exports = __webpack_public_path__ + "img/beer_id-79.f6e54472.png";